import React, { useState } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import LogoTop from "../../components/LogoTop";
import { useDispatch } from "react-redux";
import profileActions from "../../redux/profile/actions";
import { database, auth } from "../../firebase";
import Message from "./Message";
function Register(props) {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [secondPassword, setSecondPassword] = useState("");
  const [error, setError] = useState(false);
  const [terms, setTerms] = useState(false);
  const [message, setMessage] = useState(null);
  const dispatch = useDispatch();



  async function registerUser() {
    if (userName == "") {
      setMessage("Name is Required");
    }

    else if (password !== secondPassword) {
      setMessage("Passwords do not match");
    }
    else if (terms == false) {
      setMessage("Please accept Terms and Conditions");
    } else {
      setMessage(null);
      auth
        .createUserWithEmailAndPassword(email, password)
        .then((resp) => {
          let uid = resp.user.uid;
          let obj = {
            email,
            userName,
            uid,
          };
          database.ref().child("users").child(uid).push(obj);
          props.history.push("/login");
        })
        .catch((err) => {
          setMessage(err.message);
          
        });
    }
  }

  document.title = "Register";
  return (
    <>
      <LogoTop></LogoTop>

      <div className="row mx-0">
        <div
          className="col-lg-5 d-none d-lg-block p-0 min-vh-100 bg-image-cover bg-no-repeat bg-pos-center bg-dark"
          style={{ background: "url(./assets/images/register-bg.jpg)" }}
        >
          1
        </div>
        <div className="col-lg-7 min-vh-100 align-items-center d-flex bg-white">
          <div className="card shadow-none border-0 ms-auto me-auto my-auto entry-card">
            <div className="card-body rounded-0 l1">
              <h2 className="fw-bold mb-3">
                Create <br />
                your account
              </h2>
              <form autoComplete="off">
                <div className="form-group mb-3">
                  {message && <Message variant="danger">{message}</Message>}
                  <div className="input-withicon">
                    {/* {message && (
                      <h4
                        style={{
                          marginBottom: 10,
                          color: "red",
                          fontWeight: 600,
                        }}
                      >
                        Error please check your username or password
                      </h4>
                    )} */}
                    <input
                      type="text"
                      className="form-control form-control-lg fw-600"
                      id="yourname"
                      placeholder="Your Name"
                      value={userName}
                      onChange={(e) => {
                        setUserName(e.target.value);
                        setError(false);
                      }}
                    />
                    <svg className="icon icon-3x">
                      <use href="#icon_user"></use>
                    </svg>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <div className="input-withicon">
                    <input
                      type="email"
                      className="form-control form-control-lg fw-600"
                      id="email"
                      placeholder="Your Email Address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    <svg className="icon">
                      <use href="#icon_email"></use>
                    </svg>
                  </div>
                </div>
                <div className="form-group icon-input mb-3">
                  <div className="input-withicon">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      id="password"
                      placeholder="Password"
                      name="crepassword"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                    <svg className="icon">
                      <use href="#icon_lock"></use>
                    </svg>
                  </div>
                </div>
                <div className="form-group icon-input mb-1">
                  <div className="input-withicon">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      id="confirmpassword"
                      placeholder="Confirm Password"
                      name="confirm"
                      value={secondPassword}
                      onChange={(e) => {
                        setSecondPassword(e.target.value);
                      }}
                    />
                    <svg className="icon">
                      <use href="#icon_lock"></use>
                    </svg>
                  </div>
                </div>
                <div className="d-flex mb-3">
                  <label className="form-check mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      checked={terms}
                      onChange={() => setTerms(!terms)}
                    />
                    <div className="form-check-label text-grey">
                      Accept Terms and Conditions
                    </div>
                  </label>
                </div>
              </form>
              <div className="w-100">
                <div className="form-group mb-1">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary rounded-pill1 w-100"
                    onClick={() => registerUser()}
                  >
                    Register
                  </button>
                </div>
                <h6 className="text-grey text-start py-2">
                  Already have account{" "}
                  <Link
                    to="/Login"
                    className="text-decoration-none text-primary ms-1 fw-semibold"
                  >
                    Login
                  </Link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withRouter(Register);
